export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-8">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4 whitespace-nowrap">
              关于我们
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
              关于榴莲视频
            </h2>
          </div>
          <div className="bg-background-100 rounded-2xl p-6 md:p-8 border border-background-200/60">
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              榴莲视频成立于在线视频行业蓬勃发展的时代，致力于为广大观众打造一站式的在线视频平台对比导航服务。我们深知面对97视频、丝瓜视频、蓝莓视频、91在线视频、糖心视频、黑桃视频等众多平台时，用户往往难以快速做出选择——这正是榴莲视频存在的意义。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              我们以客观、全面为原则，从内容特色、使用体验、访问稳定性等多个维度对各平台进行系统化梳理。无论你是刚接触在线影视的新手，还是拥有丰富观影经验的资深用户，都能在这里找到有价值的参考信息。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              我们的团队持续追踪各平台的动态变化，确保导航信息的时效性。榴莲视频不存储任何视频内容，仅作为信息聚合平台，致力于构建一个透明、高效的在线视频平台信息生态。
            </p>
          </div>
          <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="text-center p-4">
              <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-accent-100 flex items-center justify-center">
                <i className="ri-eye-line text-xl text-accent-600"></i>
              </div>
              <p className="text-sm font-semibold text-foreground-900 whitespace-nowrap">客观对比</p>
              <p className="text-xs text-foreground-500 mt-1">多维度平台评估</p>
            </div>
            <div className="text-center p-4">
              <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-accent-100 flex items-center justify-center">
                <i className="ri-refresh-line text-xl text-accent-600"></i>
              </div>
              <p className="text-sm font-semibold text-foreground-900 whitespace-nowrap">持续更新</p>
              <p className="text-xs text-foreground-500 mt-1">追踪平台最新动态</p>
            </div>
            <div className="text-center p-4">
              <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-accent-100 flex items-center justify-center">
                <i className="ri-shield-star-line text-xl text-accent-600"></i>
              </div>
              <p className="text-sm font-semibold text-foreground-900 whitespace-nowrap">安全导航</p>
              <p className="text-xs text-foreground-500 mt-1">信息聚合不存储内容</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}